<template>
    <div>
        <div class="flex-column justify-center align-items-center" style="min-height:calc(100vh - 380px);">
            <div class="flex-column justify-center align-items-center">
                <div class="margin-bottom-30">
                    <i class="fa fa-desktop icon color-sub"></i>
                    <i class="fa fa-ban text-danger fa-2x color-red" style="margin-left:-30px"></i>
                </div>
            
                <div class="title">暂无权限</div>
                <div class="margin-top-10 margin-left-20 margin-right-20">您还没有该功能的使用权限。</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {  },
    data() {
        return {}
    },
    created() {
        
    },
    methods:{
        gotoHome(){
            
        }
    }
}
</script>
<style scoped>
    .icon{
        font-size: 100px;
    }
    .title{
        font-size: 44px;
        font-weight: bold;
    }
</style>